import { createContext } from "react";
import type { QuickPanelMessage } from "../../quickPanel.types";

export interface QuickPanelContextType {
	messages: QuickPanelMessage[];
	unreadCount: number;
	open: boolean;
	loading: {
		messages: boolean;
		messageId: string | null;
		markAll: boolean;
		downloadMessageIds: ReadonlySet<string>;
	};
	errors: {
		messages: boolean;
	};
	actions: {
		toggleQuickPanel: () => void;
		openQuickPanel: () => void;
		closeQuickPanel: () => void;
		retryMessages: () => void;
		markMessageAsRead: (message: QuickPanelMessage) => void;
		executeMessageAction: (message: QuickPanelMessage) => void;
		markAllAsRead: () => void;
	};
}

export const QuickPanelContext = createContext<QuickPanelContextType | undefined>(undefined);
